import { Box, Drawer } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import NavSection from "../../components/NavSection";
import { useContentSetting } from "../../Hooks/ContentSetting";
import sidebarConfig from "./SidebarConfig";
import { SIDEBAR_WIDTH } from "../../utils/layoutUtils";
import { s3baseUrl } from "../../config/config";

export default function AppSidebar({
  drawerWidth,
  handleDrawerToggle,
  mobileOpen,
}) {
  const { userInfo } = useContentSetting();
  const { t, i18n } = useTranslation();
  const isRtl = i18n.dir(i18n.resolvedLanguage || i18n.language) === "rtl";
  const ps = userInfo?.portal_setting;
  const brandName = (ps?.brand_name && String(ps.brand_name).trim()) || "";
  const logoSrc =
    ps?.brand_logo && String(ps.brand_logo).trim()
      ? s3baseUrl + ps.brand_logo
      : "";

  const paperSx = {
    boxSizing: "border-box",
    border: "none",
    overflowX: "hidden",
  };

  const drawer = (
    <div className="sidebar-shell">
      <div className="sidebar-shell__brand">
        <RouterLink to="/dashboard" className="sidebar-shell__brand-link">
          {logoSrc ? (
            <img
              src={logoSrc}
              alt=""
              className="app-logo sidebar-shell__logo"
              decoding="async"
            />
          ) : null}
          <div className="sidebar-shell__brand-text">
            {brandName ? (
              <span className="sidebar-shell__brand-name">{brandName}</span>
            ) : null}
            <span className="sidebar-shell__brand-tag">
              {t("sidebar.brandTag")}
            </span>
          </div>
        </RouterLink>
      </div>
      <NavSection navConfig={sidebarConfig(userInfo, t)} />
    </div>
  );

  return (
    <Box
      component="nav"
      sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
      aria-label={t("header.sidebarLandmark")}
      className="app-sidebar-box"
    >
      <Drawer
        variant="temporary"
        className="sidebar-temporary-drawer"
        anchor={isRtl ? "right" : "left"}
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": {
            ...paperSx,
            width: drawerWidth,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        className="sidebar-permanent-drawer"
        variant="permanent"
        anchor={isRtl ? "right" : "left"}
        sx={{
          display: { xs: "none", sm: "block" },
          width: { sm: drawerWidth },
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            ...paperSx,
            width: SIDEBAR_WIDTH,
            marginLeft: isRtl
              ? "0px"
              : `${drawerWidth === 0 ? -SIDEBAR_WIDTH : 0}px`,
            marginRight: isRtl
              ? `${drawerWidth === 0 ? -SIDEBAR_WIDTH : 0}px`
              : "0px",
          },
        }}
        open={Boolean(drawerWidth)}
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
